import type { CardAction } from 'src/designSystem'
import { trackMarkAsUnread } from 'src/mixpanel'
import type { MarkAsUnreadEntryType } from 'src/participantsHome/participantListAnalytics'
import { useFeedContext } from './feedContext'

/**
 * `createdAt` must be the timestamp the Unread divider compares for this row, so the divider
 * lands on the entry that was clicked.
 */
export default function useMarkAsUnreadAction(createdAt: Date, entryType: MarkAsUnreadEntryType): CardAction {
  const { markAsUnread } = useFeedContext()
  return {
    label: 'Mark as unread',
    onClick: () => {
      trackMarkAsUnread(entryType)
      markAsUnread(createdAt)
    },
  }
}
